// core version + navigation, pagination modules:
import Swiper from 'swiper'
import { $qsa, $qs } from '../../../src/js/utils/querySelector'
import { Navigation, Pagination, Autoplay, FreeMode } from 'swiper/modules'

function threeTeasersSwiper() {
    const swipers = $qsa("[data-name='swiper-three-teasers']")

    swipers.forEach((swiper) => {
        console.info('threeTeasers')
        // Find navigation buttons within this specific swiper container
        const nextButton = $qs("[data-name='swiper-button-next']", swiper)
        const prevButton = $qs("[data-name='swiper-button-prev']", swiper)

        const slider = new Swiper(swiper, {
            modules: [Navigation, Pagination, Autoplay, FreeMode],
            loop: true,
            draggable: true,
            allowTouchMove: true,
            effect: 'slide',

            // Base configuration for mobile
            slidesPerView: 1,
            spaceBetween: 50,
            autoHeight: false,
            autoplay: false,

            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },

            pagination: false,

            // Responsive breakpoints
            breakpoints: {
                // Medium devices and up
                768: {
                    slidesPerView: 2,
                    spaceBetween: 50,
                },
                1115: {
                    slidesPerView: 3,
                    spaceBetween: 50,
                },
            },
        })
    })
}

export default threeTeasersSwiper
